import { OrderAscendingIcon } from 'tdesign-icons-vue-next';
import { shallowRef } from 'vue';
import { RouteRecordRaw } from 'vue-router';

export default [
  {
    path: '/order-manager',
    component: () => import('@/layouts/index.vue'),
    redirect: '/order-manager/order-list',
    name: 'orderManager',
    meta: {
      title: '订单管理',
      icon: shallowRef(OrderAscendingIcon),
      orderNo: 0,
      permission: ['SalesOrderList', 'SalesOrderAccurateQueryList'],
    },
    children: [
      {
        path: 'order-list',
        name: 'orderList',
        component: () => import('@/pages/order-management/orders/order-list.vue'),
        meta: {
          title: '订单列表',
          permission: ['SalesOrderList'],
        },
      },
      {
        path: 'order-exact-list',
        name: 'orderExactList',
        component: () => import('@/pages/order-management/exact-order/exact-order-list.vue'),
        meta: {
          title: '精确查询',
          permission: ['SalesOrderAccurateQueryList'],
        },
      },
      {
        path: 'inventory-order-list',
        name: 'inventoryOrderList',
        component: () => import('@/pages/order-management/inventory-order/inventory-order-list.vue'),
        meta: {
          title: '库存订单',
          permission: ['InventoryOrderList'],
        },
      },
      {
        path: 'add-inventory-order',
        name: 'addInventoryOrder',
        component: () => import('@/pages/order-management/inventory-order/add-inventory-order.vue'),
        meta: {
          title: '新增库存订单',
          hidden: true,
          permission: ['InventoryOrderCreate'],
          parentRouteName: 'inventoryOrderList',
        },
      },
      {
        path: 'add-order',
        name: 'addOrder',
        component: () => import('@/pages/order-management/orders/add-order.vue'),
        meta: {
          title: '新增订单',
          hidden: true,
          permission: ['SalesOrderDoorCreate', 'SalesOrderAccessoriesCreate'],
          parentRouteName: 'orderList',
        },
      },
      {
        path: 'order-detail',
        name: 'orderDetail',
        component: () => import('@/pages/order-management/orders/order-detail.vue'),
        meta: {
          title: '订单详情',
          hidden: true,
          permission: ['SalesOrderDetails'],
          parentRouteName: 'orderList',
        },
      },
      {
        path: 'order-exact-detail',
        name: 'orderExactDetail',
        component: () => import('@/pages/order-management/exact-order/exact-order-detail.vue'),
        meta: {
          title: '订单详情',
          hidden: true,
          permission: ['SalesOrderAccurateQueryDetails'],
          parentRouteName: 'orderExactList',
        },
      },
    ],
  },
] as RouteRecordRaw[];
